import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import {
	defaultKybCredentials,
	type IKybCredentials,
	type IKybDetails,
	kybDefaultData,
	type PreviewFileMeta,
} from 'BreetHelpers';

import { reduxPersistor } from '@/lib';

const persistedState = typeof window !== 'undefined' ? reduxPersistor.getData('app') : null;

export interface KybAuthState {
	kybCredentials: IKybCredentials;
	formData: Partial<IKybDetails>;
	isLoadingKybDetails: boolean;
	previewFile: PreviewFileMeta;
}

const getKybCredentials = () => {
	if (persistedState?.kybCredentials) return persistedState.kybCredentials;
	return defaultKybCredentials;
};

const initialState: KybAuthState = {
	kybCredentials: getKybCredentials(),
	formData: kybDefaultData,
	isLoadingKybDetails: false,
	previewFile: {
		fileSelectorId: '',
		previewUrl: '',
		type: '',
	},
};

export const kybAuthSlice = createSlice({
	name: 'kybAuth',
	initialState,
	reducers: {
		setKybCredentials: (state, action: PayloadAction<IKybCredentials>) => {
			state.kybCredentials = action.payload;
		},
		setFormData: (state, action: PayloadAction<Partial<IKybDetails>>) => {
			state.formData = action.payload;
		},
		setPreviewFile: (state, action: PayloadAction<PreviewFileMeta>) => {
			state.previewFile = action.payload;
		},
		setIsLoadingKybDetails: (state, action: PayloadAction<boolean>) => {
			state.isLoadingKybDetails = action.payload;
		},
		logKybUserOut: (state) => {
			state.kybCredentials = defaultKybCredentials;
		},
	},
	selectors: {
		selectKybCredentials: (state) => state.kybCredentials,
		selectKybFormData: (state) => state.formData,
		selectIsLoadingKybDetails: (state) => state.isLoadingKybDetails,
		selectPreviewFile: (state) => state.previewFile,
	},
});

export const kybAuthAction = kybAuthSlice.actions;

export const { logKybUserOut, setKybCredentials, setFormData } = kybAuthSlice.actions;

export default kybAuthSlice.reducer;

export const kybAuthSelectors = kybAuthSlice.selectors;
